import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Row,
  Form,
  Spinner,
  Offcanvas,
  Badge,
  Tooltip,
  OverlayTrigger
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import * as Moment from 'moment';
import { usePagination, useSortBy, useTable } from 'react-table';
import PropTypes from 'prop-types';
import { DeleteAd, IndexAd } from '../../../../../services/AdService';
import { Link, useSearchParams } from 'react-router-dom';
import ExportAds from '../../../../../exports/ads';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import IconButton from '../../../../common/IconButton';
import IndexAdsCategories from './categories';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import FormAlert from '../../../commons/FormAlert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine';
import { IndexAdTrack } from '../../../../../services/AdTrackService';
import ExportTracks from '../../../../../exports/tracks';

const IndexAds = ({ fromMembers = false }) => {
  const [searchParams] = useSearchParams();
  const [trigger, setTrigger] = useState(Date.now());
  const [initialApiObjects, setInitialApiObjects] = useState([]);
  const [objects, setObjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedObject, setSelectedObject] = useState({});
  const [showDelete, setShowDelete] = useState(false);
  const [initialObjects, setInitialObjects] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [showIndexCategories, setShowIndexCategories] = useState(false);
  const [errorForm, setErrorForm] = useState(false);
  const [cancelReason, setCancelReason] = useState([]);
  const [indexTracks, setIndexTracks] = useState([]);
  const [showStats, setShowStats] = useState(false);

  const transformObjects = objects => {
    let transformedApiObjects = [];
    objects.map(obj => {
      transformedApiObjects.push({
        object: obj,
        id: obj.id,
        user: (
          <>
            {obj.user?.firstname} {obj.user?.lastname}
            <br />
            <small>{obj.company?.name}</small>
          </>
        ),
        title: (
          <a
            target="_blank"
            rel="noreferrer"
            href={`/espace-membre/annonces/${obj.id}`}
          >
            {obj.title}
          </a>
        ),
        category: `${
          obj.category.parent ? `${obj.category.parent.name} > ` : ''
        }${obj.category.name}`,
        price: obj.price,
        status: (
          <>
            {obj.deleted_at && (
              <Badge pill bg="danger">
                Supprimée
              </Badge>
            )}
            {obj.is_active === 1 && (
              <Badge pill bg="success">
                Publiée
              </Badge>
            )}
            {obj.cancel_reason ? (
              <Badge pill bg="warning">
                {obj.cancel_reason}
              </Badge>
            ) : !obj.validated_at ? (
              <Badge pill bg="warning">
                Modération Tred Union
              </Badge>
            ) : obj.is_active === 0 ? (
              <Badge pill bg="danger">
                Dépubliée
              </Badge>
            ) : (
              ''
            )}
          </>
        ),
        validity: Moment(obj.validity).isBefore(Moment()) ? (
          <span className="text-danger">
            {Moment(obj.validity).local().format('DD/MM/YYYY')}
          </span>
        ) : (
          <span className="">
            {Moment(obj.validity).local().format('DD/MM/YYYY')}
          </span>
        ),
        created_at: Moment(obj.created_at).local().format('DD/MM/YYYY'),
        actions: (
          <>
            {!obj.deleted_at && (
              <Col className="px-0">
                {!obj.cancel_reason && (
                  <Button
                    size="sm"
                    variant="primary"
                    className="me-2 admin-primary"
                    type="button"
                    onClick={() => {
                      if (fromMembers) {
                        window.location.href = `/espace-membre/mes-annonces/${obj.id}/modifier`;
                      } else {
                        window.location.href = `/administration/annonces/${obj.id}/modifier`;
                      }
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="14"
                      height="14"
                      style={{
                        marginBottom: '2px',
                        marginRight: '3px'
                      }}
                    >
                      <path
                        d="M16.757 3l-2 2H5v14h14V9.243l2-2V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12.757zm3.728-.9L21.9 3.516l-9.192 9.192-1.412.003-.002-1.417L20.485 2.1z"
                        fill="rgba(255,255,255,1)"
                      />
                    </svg>
                  </Button>
                )}
                <Button
                  size="sm"
                  variant="danger"
                  className="me-0"
                  type="button"
                  onClick={() => {
                    setShowDelete(true);
                    setSelectedObject(obj);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="14"
                    height="14"
                    style={{
                      marginBottom: '2px'
                    }}
                  >
                    <path
                      d="M7 4V2h10v2h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2V4h5zM6 6v14h12V6H6zm3 3h2v8H9V9zm4 0h2v8h-2V9z"
                      fill="rgba(255,255,255,1)"
                    />
                  </svg>
                </Button>
              </Col>
            )}
            <OverlayTrigger
              overlay={
                <Tooltip id="overlay-trigger-example">Statistiques</Tooltip>
              }
            >
              <Button
                size="sm"
                variant="falcon-default"
                className="mb-2 d-block"
                type="button"
                onClick={async () => {
                  const response = await IndexAdTrack(obj.id);
                  if (response.success === true) {
                    setIndexTracks(response.data);
                    setShowStats(true);
                  } else {
                    toast(
                      'Une erreur est survenue, veuillez réessayer plus tard'
                    );
                  }
                }}
              >
                <FontAwesomeIcon icon={faChartLine} />
              </Button>
            </OverlayTrigger>
          </>
        )
      });
    });
    setInitialObjects(transformedApiObjects);
    setObjects(transformedApiObjects);
  };

  useEffect(() => {
    const fetchObjects = async () => {
      const responseObjects = await IndexAd(
        fromMembers,
        searchParams.get('withtrashed')
      );
      if (responseObjects.success === true) {
        setInitialApiObjects(responseObjects.data);
        setIsLoading(false);
        transformObjects(responseObjects.data);
      } else {
        toast('Une erreur est survenue, veuillez réessayer plus tard');
      }
    };
    fetchObjects();
  }, [trigger]);

  const deleteObject = async () => {
    setErrorForm(false);
    const response = await DeleteAd(selectedObject.id, cancelReason);
    setErrorForm(response.validator);
    if (response.success === true) {
      setShowDelete(false);
      toast('Annonce supprimée');
      setTrigger(Date.now());
    } else {
      toast('Une erreur est survenue, veuillez réessayer plus tard');
    }
  };

  const applySearch = (value, objects) => {
    if (value) {
      let searchObjects = [];
      searchObjects = objects.filter(object => {
        return (
          object.title
            .toLowerCase()
            .replace('.', '')
            .indexOf(searchInput.toLowerCase().replace('.', '')) > -1
        );
      });
      setInitialApiObjects(searchObjects);
    } else {
      setInitialApiObjects(objects);
    }
  };

  return (
    <>
      <Offcanvas
        show={showStats}
        onHide={() => {
          setShowStats(false);
        }}
        placement={'end'}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Statistiques de l'annonce</Offcanvas.Title>
        </Offcanvas.Header>
        {indexTracks.length > 0 ? (
          <Offcanvas.Body>
            <>
              <table className="table-stats-tracks">
                <thead>
                  <tr>
                    <th scope="col">Action</th>
                    <th scope="col">Initiateur</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {indexTracks.map((track, index) => (
                    <tr key={index}>
                      <td>Vue</td>
                      <td>
                        {track.user !== undefined && track.user !== null && (
                          <>
                            {track.user.lastname} {track.user.firstname}
                            {track.user.main_company !== undefined &&
                              track.user.main_company !== null && (
                                <> ({track.user.main_company.name})</>
                              )}
                          </>
                        )}
                      </td>
                      <td>
                        {Moment(track.created_at).local().format('DD/MM/YYYY')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <ExportTracks tracks={indexTracks} />
            </>
          </Offcanvas.Body>
        ) : (
          <Offcanvas.Body>Aucune statistique pour le moment.</Offcanvas.Body>
        )}
      </Offcanvas>
      <Offcanvas
        show={showDelete}
        onHide={() => {
          setShowDelete(false);
        }}
        placement={'end'}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {selectedObject.id !== undefined && (
              <>
                L'archivage de l'annonce "{selectedObject.title}" est définitif.
              </>
            )}
            <br />
            Voulez-vous continuer ?
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {errorForm && (
            <div className="mt-3">
              <FormAlert variant="danger" data={errorForm} />
            </div>
          )}
          <Form.Group controlId="headquarter_id" className="mb-3">
            <Form.Label>Raison de la suppression : </Form.Label>
            <Form.Select
              aria-label="Choisir une raison"
              name="cancel_reason"
              value={cancelReason}
              onChange={e => {
                setCancelReason(e.target.value);
              }}
            >
              <option value="">Choisir</option>
              <option value={`Je n'ai pas vendu mon bien`}>
                Je n'ai pas vendu mon bien
              </option>
              <option value={`J'ai vendu mon bien à un adhérent Tred Union`}>
                J'ai vendu mon bien à un adhérent Tred Union
              </option>
              <option value={`J'ai vendu mon bien hors de Tred Union`}>
                J'ai vendu mon bien hors de Tred Union
              </option>
              <option value={`Autre`}>Autre</option>
            </Form.Select>
          </Form.Group>
          <Button
            size="sm"
            variant="falcon-danger"
            className="me-2"
            onClick={() => {
              deleteObject();
            }}
          >
            Oui, archiver
          </Button>
          <Button
            size="sm"
            variant="falcon-default"
            className="me-2"
            onClick={() => {
              setShowDelete(false);
            }}
          >
            Annuler
          </Button>
        </Offcanvas.Body>
      </Offcanvas>
      <Card>
        <Card.Body className="overflow-hidden px-lg-3">
          <Row className="justify-content-between align-items-center">
            <Col xs={6}>
              <h3 className="text-primary admin-title mb-0">
                Petites annonces
              </h3>
            </Col>
            <Col xs={6} className="text-end">
              {!fromMembers ? (
                <IconButton
                  className="w-auto me-2"
                  variant="falcon-default"
                  size="sm"
                  icon={faList}
                  transform="shrink-3"
                  onClick={() => {
                    setShowIndexCategories(true);
                  }}
                >
                  Gestion des catégories
                </IconButton>
              ) : (
                <IconButton
                  className="w-auto me-2"
                  variant="falcon-default"
                  size="sm"
                  icon={faChevronLeft}
                  transform="shrink-3"
                  onClick={() => {
                    window.location.href = '/espace-membre/annonces';
                  }}
                >
                  Retour
                </IconButton>
              )}
              <Button
                variant="primary"
                className="admin-primary"
                size="sm"
                as={Link}
                to={
                  fromMembers
                    ? '/espace-membre/mes-annonces/ajouter'
                    : '/administration/annonces/ajouter'
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  style={{ marginBottom: '2px', marginRight: '2px' }}
                >
                  <path
                    d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z"
                    fill="rgba(255,255,255,1)"
                  />
                </svg>
                Ajouter
              </Button>
              <IndexAdsCategories
                showIndexCategories={showIndexCategories}
                setShowIndexCategories={setShowIndexCategories}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {isLoading === true && (
        <Row>
          <Col xs={12} className="mt-3">
            <Spinner animation="border" role="status" size="xs">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Col>
        </Row>
      )}
      <Card className="mt-3">
        <Card.Body className="">
          <Row className="justify-content-between align-items-center px-3">
            {!fromMembers && (
              <Col xs={12} className="mb-3 text-end">
                <label>
                  <input
                    type="checkbox"
                    id="is_admin"
                    name="is_admin"
                    value="1"
                    className="me-1"
                    checked={searchParams.get('withtrashed') === 'true'}
                    onChange={() => {
                      if (searchParams.get('withtrashed') === 'true') {
                        window.location.href = '/administration/annonces';
                      } else {
                        window.location.href =
                          '/administration/annonces?withtrashed=true';
                      }
                    }}
                  />
                  Afficher les annonces archivées
                </label>
              </Col>
            )}
            <Col xs={12} className="mb-0 px-0">
              <Form.Control
                type="search"
                className="search-input"
                placeholder="Rechercher quelque chose..."
                aria-label="Search"
                value={searchInput}
                size="sm"
                onChange={e => {
                  setSearchInput(e.target.value);
                  applySearch(e.target.value, initialObjects);
                }}
              />
            </Col>
          </Row>
          {initialApiObjects.length > 0 && (
            <Row>
              {objects && objects.length > 0 && (
                <Col xs={12} className="mt-3">
                  <Table data={objects} />
                </Col>
              )}
            </Row>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

function Table({ data }) {
  const columns = React.useMemo(
    () => [
      {
        accessor: 'title',
        Header: 'Titre'
      },
      {
        accessor: 'category',
        Header: 'Catégorie'
      },
      {
        accessor: 'price',
        Header: 'Prix'
      },
      {
        accessor: 'status',
        Header: 'Statut'
      },
      {
        accessor: 'validity',
        Header: 'Validité',
        sortType: (a, b) => {
          var a1 = new Date(a).getTime();
          var b1 = new Date(b).getTime();
          if (a1 < b1) return 1;
          else if (a1 > b1) return -1;
          else return 0;
        }
      },
      {
        accessor: 'created_at',
        Header: 'Créée le',
        sortType: (a, b) => {
          var a1 = new Date(a).getTime();
          var b1 = new Date(b).getTime();
          if (a1 < b1) return 1;
          else if (a1 > b1) return -1;
          else return 0;
        }
      },
      {
        accessor: 'user',
        Header: 'Auteur'
      },
      {
        accessor: 'actions',
        Header: 'Actions'
      }
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 15 }
    },
    useSortBy,
    usePagination
  );

  return (
    <>
      <div className="table-responsive scrollbar-visible table-container">
        <table
          {...getTableProps()}
          className="table table-striped table-bordered admin-table w-100 d-block d-table"
        >
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr
                className="table-fixed-header"
                key={index}
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map(column => (
                  <th
                    key={`${index}${Date.now()}`}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z" />
                          </svg>
                        )
                      ) : (
                        ''
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr key={i} {...row.getRowProps()}>
                  {row.cells.map((cell, indexCell) => {
                    return (
                      <td key={indexCell} {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="pagination d-block mt-3">
        <Button
          variant="falcon-primary"
          size="sm"
          className="me-2"
          onClick={() => {
            gotoPage(0);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          disabled={!canPreviousPage}
        >
          {'<<'}
        </Button>
        <Button
          variant="falcon-primary"
          size="sm"
          className="me-2"
          onClick={() => {
            previousPage();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          disabled={!canPreviousPage}
        >
          {'<'}
        </Button>
        <Button
          variant="falcon-primary"
          size="sm"
          className="me-2"
          onClick={() => {
            nextPage();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          disabled={!canNextPage}
        >
          {'>'}
        </Button>
        <Button
          variant="falcon-primary"
          size="sm"
          className="me-3"
          onClick={() => {
            gotoPage(pageCount - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          disabled={!canNextPage}
        >
          {'>>'}
        </Button>{' '}
        <span className="bottom-table">
          Page{' '}
          <strong>
            {pageIndex + 1} sur {pageOptions.length}
          </strong>{' '}
        </span>
        <Form.Select
          className="d-inline-block w-auto ms-3 table-select"
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value));
          }}
          aria-label="Default select example"
        >
          {[15, 30, 50, 100, 150].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Afficher {pageSize} éléments
            </option>
          ))}
        </Form.Select>
        <ExportAds logs={data} />
      </div>
    </>
  );
}

Table.propTypes = {
  data: PropTypes.array
};

IndexAds.propTypes = {
  fromMembers: PropTypes.bool
};

export default IndexAds;
